import "../../../FhDropdownBaseItem.css";
import { computed, openBlock, createElementBlock, mergeProps, withKeys, withModifiers, createElementVNode, renderSlot, createBlock, createCommentVNode, normalizeClass, createVNode, withCtx } from "vue";
import FhText from "../../FhText/FhText.mjs";
import FhIcon from "../../FhIcon/FhIcon.mjs";
import { VARIANTS_ENUMS } from "../FhDropdownItem/constants.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = ["aria-disabled", "onKeydown"];
const _hoisted_2 = { class: "fh-dropdown-item-wrapper" };
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhDropdownBaseItem",
  props: {
    prefixIcon: {
      type: String,
      default: ""
    },
    suffixIcon: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: VARIANTS_ENUMS.DEFAULT,
      validator: (value) => Object.values(VARIANTS_ENUMS).includes(value)
    },
    hoverable: {
      type: Boolean,
      default: true
    },
    activable: {
      type: Boolean,
      default: true
    }
  },
  emits: ["select"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const computedClasses = computed(() => [
      "fh-dropdown-item",
      props.variant && `fh-dropdown-item--${props.variant}`,
      props.disabled && "fh-dropdown-item--disabled",
      props.selected && "fh-dropdown-item--selected",
      "fh-dropdown-focusable",
      props.hoverable && !props.disabled && "fh-dropdown-item--hoverable",
      props.activable && !props.disabled && "fh-dropdown-item--activable"
    ]);
    const computedTextColor = computed(() => {
      switch (true) {
        case props.disabled:
          return "disabled";
        case (props.selected && props.variant === "default"):
          return "primary-default";
        case (props.selected && props.variant === "destructive"):
          return "error-default";
        case props.variant === "destructive":
          return "error-default";
        default:
          return "default";
      }
    });
    const computedIconColor = computed(() => {
      switch (true) {
        case props.disabled:
          return "disabled";
        case (props.selected && props.variant === "default"):
          return "primary-default";
        case (props.selected && props.variant === "destructive"):
          return "error-default";
        case props.variant === "destructive":
          return "error-default";
        default:
          return "default";
      }
    });
    const computedDescriptionColor = computed(
      () => props.disabled ? "disabled" : "subtle"
    );
    const handleSelect = (event) => {
      if (!props.disabled) {
        emit("select", event);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", mergeProps({
        class: computedClasses.value,
        "aria-disabled": props.disabled,
        tabindex: "0",
        onClick: handleSelect,
        onKeydown: withKeys(withModifiers(handleSelect, ["prevent"]), ["space", "enter"]),
        role: "menuitem"
      }, _ctx.$attrs), [
        createElementVNode("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "input", {}, void 0, true),
          props.prefixIcon ? (openBlock(), createBlock(FhIcon, {
            key: 0,
            size: "sm",
            color: computedIconColor.value,
            icon: props.prefixIcon,
            class: "fh-dropdown-item-prefix"
          }, null, 8, ["color", "icon"])) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass([
              "fh-dropdown-item-content",
              _ctx.$slots["description-block"] && !_ctx.$slots["description-inline"] ? "fh-dropdown-item-content--block" : "fh-dropdown-item-content--inline"
            ])
          }, [
            createVNode(FhText, {
              tag: "span",
              variant: "body-md",
              color: computedTextColor.value
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default", {}, void 0, true)
              ]),
              _: 3
            }, 8, ["color"]),
            _ctx.$slots["description-inline"] ? (openBlock(), createBlock(FhText, {
              key: 0,
              tag: "span",
              variant: "body-sm",
              color: computedDescriptionColor.value
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "description-inline", {}, void 0, true)
              ]),
              _: 3
            }, 8, ["color"])) : createCommentVNode("", true),
            !_ctx.$slots["description-inline"] && _ctx.$slots["description-block"] ? (openBlock(), createBlock(FhText, {
              key: 1,
              tag: "p",
              variant: "body-sm",
              color: computedDescriptionColor.value
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "description-block", {}, void 0, true)
              ]),
              _: 3
            }, 8, ["color"])) : createCommentVNode("", true)
          ], 2),
          props.suffixIcon ? (openBlock(), createBlock(FhIcon, {
            key: 1,
            size: "sm",
            color: computedIconColor.value,
            icon: props.suffixIcon,
            class: "fh-dropdown-item-suffix"
          }, null, 8, ["color", "icon"])) : createCommentVNode("", true)
        ])
      ], 16, _hoisted_1);
    };
  }
});
const FhDropdownBaseItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-06ad117b"]]);
export {
  FhDropdownBaseItem as default
};
//# sourceMappingURL=FhDropdownBaseItem.mjs.map
